import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { BlueprintIntegrationAttachment } from "types/generated";

type IntegrationUsedByTableDropdownCellProps = TableSimpleCellProps<BlueprintIntegrationAttachment>;

const IntegrationUsedByTableDropdownCell = ({
  ...cellProps
}: IntegrationUsedByTableDropdownCellProps) => {
  return <TableSimpleCell {...cellProps} />;
};

export default IntegrationUsedByTableDropdownCell;
